import {Dispatch} from "redux";
import {getContainer} from "../ioc/IOCSetup";
import {UserGameReward} from "../http/protocol";

export enum UserRewardActionTypes {
    REWARDS_REQUEST = "@rewards/request",
    REWARDS_RESPONSE ="@rewards/response",
    REWARDS_ERROR = "@rewards/error",
}
export type UserRewardActions =
    | { type : UserRewardActionTypes.REWARDS_REQUEST }
    | { type : UserRewardActionTypes.REWARDS_ERROR }
    | { type : UserRewardActionTypes.REWARDS_RESPONSE, rewards : UserGameReward[]}

export const fetchRewards = (markAsRead? : boolean) => {
    return (dispatch : Dispatch) => {
        dispatch({ type : UserRewardActionTypes.REWARDS_REQUEST});
        getContainer().getUserRewardService().getRewards().then( r => {
            let items = r.items;
            if(markAsRead) {
                getContainer().getUserRewardService().marAllAsRead();
                items = items?.map(i => {
                    i.messageRead = true
                    return i;
                });
            }
            dispatch({ type : UserRewardActionTypes.REWARDS_RESPONSE, rewards :items })
        }).catch((e) => {
            dispatch({ type : UserRewardActionTypes.REWARDS_ERROR });
        })
    }
}